import React, { FunctionComponent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, FavoriteButton, Layout } from '@vwfs-bronson/bronson-react';
import { loginAsOutlet } from '../../../services/api/authorization';
import { storage } from '../../../services/localStorage';
import { brokerSelectors, setFavouriteCompanyId } from '../../../services/redux/features/broker.slice';

type Props = {
  company: DealerIntegration.Components.Schemas.MilesBrokerCompaniesData;
  companySearchText: string;
};

export const getCompanyDisplayText = (company?: DealerIntegration.Components.Schemas.MilesBrokerCompaniesData) => {
  return `${company?.milesBerCode}/${company?.brand?.name}`;
};

export const CompanyListItemForModal: FunctionComponent<Props> = ({ company, companySearchText }) => {
  const selectedCompany = useSelector(brokerSelectors.currentCompany);
  const favouriteCompanyId = useSelector(brokerSelectors.favouriteCompanyId);
  const dispatch = useDispatch();

  const itemText = getCompanyDisplayText(company);
  const isMatchingSearchText = !companySearchText || itemText.toLowerCase().includes(companySearchText.toLowerCase());
  const companyIsSelected = company.milesCompanyId === selectedCompany?.milesCompanyId;
  const companyIsFavourite = favouriteCompanyId === company.milesCompanyId;

  return (
    <Layout middle center className="u-p-xsmall">
      <Layout.Item default="3/4">
        <Button
          className={
            (companyIsSelected ? 'u-text-pale u-bg-brand' : 'u-bg-white') + (isMatchingSearchText ? '' : ' u-text-pale')
          }
          simple
          small
          full
          disabled={companyIsSelected || !isMatchingSearchText}
          onClick={() => {
            loginAsOutlet(company.milesCompanyId!, true);
          }}
        >
          {itemText}
        </Button>
      </Layout.Item>
      <Layout.Item default="1/4">
        <Layout center>
          {isMatchingSearchText && (
            <FavoriteButton
              active={companyIsFavourite}
              iconOnly
              onPressedChange={() => {
                if (companyIsFavourite) {
                  dispatch(setFavouriteCompanyId(undefined));
                  storage.favouriteCompanyId = undefined;
                } else {
                  dispatch(setFavouriteCompanyId(company.milesCompanyId!));
                  storage.favouriteCompanyId = company.milesCompanyId;
                }
              }}
            />
          )}
        </Layout>
      </Layout.Item>
    </Layout>
  );
};
